import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Add for navigation
import { jwtDecode } from 'jwt-decode';
import AboutUsAdmin from './AboutUs';


const AdminAdd = () => {

    
const token = sessionStorage.getItem('authToken');
const currentTime = Date.now() / 1000; // Current time in seconds


    const [adminCredentials, setAdminCredentials] = useState({ username: '', password: '', role: 'Admin' }); // Default role set to 'Editor'
    const [confirmPassword, setConfirmPassword] = useState('');
    const [formMessage, setFormMessage] = useState('');
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false); // Loading state for admin fetch and form submission
    const [isTokenValid, setIsTokenValid] = useState(true); // Token validity state
    const navigate = useNavigate(); // Hook to navigate if token expires
    useEffect(() => {
        fetchAdmins(); // Fetch existing admins on component mount
    }, []);

    const fetchAdmins = async () => {
        setLoading(true); // Set loading to true when fetching admins
        try {
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);

                    const expiryTime = decodedToken.exp; // Token expiration time from the JWT

                    // Check if the token is expired
                    if (expiryTime < currentTime) {
                        setIsTokenValid(false);
                        setFormMessage('Your session has expired. Please log in again.');
                    } else {
                        setIsTokenValid(true);
                        // Token is still valid, continue with your logic
                    }
                } catch (error) {
                    console.error("Error decoding the token", error);
                    setIsTokenValid(false);
                    setFormMessage('Invalid token. Please log in again.');
                }
            } else {
                setIsTokenValid(false);
                setFormMessage('Please log in first.');
            }
            

            const response = await axios.get('https://zoomautos.co.uk/api/admins', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setAdmins(response.data); // Set fetched admins
            setLoading(false); // Stop loading after fetching
        } catch (error) {
            setLoading(false);
            setFormMessage('Failed to load admins.');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAdminCredentials((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if the passwords match
        if (confirmPassword !== adminCredentials.password) {
            setFormMessage('Passwords do not match!');
            return;
        }
        if (token) {
            try {
                const decodedToken = jwtDecode(token);

                const expiryTime = decodedToken.exp; // Token expiration time from the JWT

                // Check if the token is expired
                if (expiryTime < currentTime) {
                    setIsTokenValid(false);
                    setFormMessage('Your session has expired. Please log in again.');
                } else {
                    setIsTokenValid(true);
                    // Token is still valid, continue with your logic
                }
            } catch (error) {
                console.error("Error decoding the token", error);
                setIsTokenValid(false);
                setFormMessage('Invalid token. Please log in again.');
            }
        } else {
            setIsTokenValid(false);
            setFormMessage('Please log in first.');
        }
        

        setLoading(true); // Start loading

        try {
            // Send a POST request to add the new admin
            const response = await axios.post(
    'https://zoomautos.co.uk/api/admins',
    adminCredentials,
    {
        headers: {
            Authorization: `Bearer ${token}`, // Add the token to the header
        },
    }
)

            if (response.status === 201) {
                setFormMessage('Admin added successfully!');
                setAdminCredentials({ username: '', password: '', role: 'Admin' });
                setConfirmPassword(''); // Clear confirm password
                fetchAdmins(); // Refresh the list of admins
            } else {
                setFormMessage('Error adding admin: ' + (response.data.message || 'Unknown error'));
            }
        } catch (error) {
            setFormMessage('Error adding admin: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false); // Stop loading after submission
        }
    };

    const handleDelete = async (username) => {
        if (!window.confirm(`Are you sure you want to delete admin "${username}"?`)) {
            return;
        }

        setLoading(true); // Start loading

        try {
            await axios.delete(`https://zoomautos.co.uk/api/admins/${username}`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            setFormMessage('Admin deleted successfully!');
            fetchAdmins(); // Refresh the list of admins
        } catch (error) {
            setFormMessage('Error deleting admin. Please try again.');
        } finally {
            setLoading(false); // Stop loading after deletion
        }
    };

    if (!isTokenValid) {
        navigate('/Admin'); // Redirect to login page if token is invalid or expired
    }

    return (
        <div className="adminaddform-container" style={{ marginTop: '200px', marginBottom: '200px' }}>
            <h2>Add Admin</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            name="username"
                            placeholder="Username"
                            value={adminCredentials.username}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={adminCredentials.password}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label>Role</label>
                        <select
                            name="role"
                            value={adminCredentials.role}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="SuperAdmin">SuperAdmin</option>
                            <option value="Admin">Admin</option>
                            
                        </select>
                    </div>
                </div>
                <div className="form-row">
                    <button className="contact-button" type="submit" style={{ width: '100%' }} disabled={loading}>
                        {loading ? 'Adding...' : 'Add Admin'}
                    </button>
                </div>
            </form>
            {formMessage && (
                <p style={{ color: formMessage.includes('success') ? 'green' : 'red' }}>
                    {formMessage}
                </p>
            )}

            <h2>Existing Admins</h2>
            {loading ? (
                <p>Loading admins...</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid black', padding: '10px' }}>Username</th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>Password</th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>Role</th>
                            <th style={{ border: '1px solid black', padding: '10px' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {admins.map((admin) => (
                            <tr key={admin.username}>
                                <td style={{ border: '1px solid black', padding: '10px' }}>{admin.username}</td>
                                <td style={{ border: '1px solid black', padding: '10px' }}>{admin.password}</td>
                                <td style={{ border: '1px solid black', padding: '10px' }}>{admin.role}</td>
                                <td style={{ border: '1px solid black', padding: '10px' }}>
                                    <button
                                        onClick={() => handleDelete(admin.username)}
                                        className='contact-button'
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <AboutUsAdmin/>
        </div>
    );
};

export default AdminAdd;
